import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  useCallback,
} from "react";

const SelectedChannelsContext = createContext();

export const SelectedChannelsProvider = ({ children }) => {
  const [selectedChannels, setSelectedChannels] = useState([]);

  const addChannel = useCallback((channel) => {
    setSelectedChannels((prev) => {
      const exists = prev.some((item) => item.id === channel.id);
      if (!exists) {
        return [
          ...prev,
          { id: channel.id, name: channel.name, owner: channel.owner },
        ];
      }
      return prev;
    });
  }, []);

  const removeChannel = useCallback((id) => {
    setSelectedChannels((prev) => prev.filter((channel) => channel.id !== id));
  }, []);

  const isChannelSelected = useCallback(
    (id) => selectedChannels.some((channel) => channel.id === id),
    [selectedChannels]
  );

  const resetChannelArray = useCallback(() => setSelectedChannels([]), []);

  const contextValue = useMemo(
    () => ({
      selectedChannels,
      addChannel,
      removeChannel,
      isChannelSelected,
      resetChannelArray,
    }),
    [
      selectedChannels,
      addChannel,
      removeChannel,
      isChannelSelected,
      resetChannelArray,
    ]
  );

  return (
    <SelectedChannelsContext.Provider value={contextValue}>
      {children}
    </SelectedChannelsContext.Provider>
  );
};

export const useSelectedChannels = () => useContext(SelectedChannelsContext);
